import { Component, OnInit, Input } from '@angular/core';

import { InvestOutputItem } from '@classes/invest/invest-sic/invest-output-item';
import { RateCurve } from '@classes/invest/rate-curve';
import { ReportDataType } from '@enums/report-data-type.enum';

@Component({
    selector: 'app-results',
    templateUrl: './results.component.html',
    styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {
    @Input() itemsTitle: string;
    @Input() items: InvestOutputItem[] | RateCurve[];

    reportDataType = ReportDataType;

    constructor() {}

    ngOnInit() {
    }
}
